import { render, staticRenderFns } from "./cadastro-sem-senha.vue?vue&type=template&id=fc8361bc&"
import script from "./cadastro-sem-senha.vue?vue&type=script&lang=js&"
export * from "./cadastro-sem-senha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports